module.exports = __webpack_public_path__ + "img/health-managers.b82a8630.svg";